import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "reset-form" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"side\"><div class=\"side-text-wrap\"><div class=\"welcome-text\">WELCOME BACK</div><a href=\"/\"><img class=\"logo\" src=\"/images/auth/login-logo.png\" alt=\"\"></a></div></div>", 1)
const _hoisted_3 = { class: "form-container" }
const _hoisted_4 = { class: "text-dark auth-language-dropdown" }
const _hoisted_5 = { class: "reset-form" }
const _hoisted_6 = ["validation-schema"]
const _hoisted_7 = { class: "title" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "mb-6" }
const _hoisted_10 = { class: "d-flex justify-content-between mb-1" }
const _hoisted_11 = { class: "label required" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "fv-plugins-message-container" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "mb-6" }
const _hoisted_17 = { class: "d-flex justify-content-between mb-1" }
const _hoisted_18 = { class: "label required" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_24 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

import * as Yup from "yup";
import { useStore } from "@/store";
import { ref, onMounted } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { ErrorMessage, Field, useForm } from "vee-validate";
import LanguageDropdown from "../../components/LanguageDropdown.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import GlobalService from "@/projects/client/services/ClientGlobalService";
import { useRoute, useRouter } from "vue-router";
import i18n from "@/core/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeTradeAccountPassword',
  setup(__props) {

const { t } = i18n.global;
const store = useStore();
const route = useRoute();
const router = useRouter();
const isLoading = ref(true);
const accountNumber = ref<any>("");
const tenantId = ref<any>("");
const passwordShow_1 = ref(false);
const passwordShow_2 = ref(false);
const formData = ref<any>({
  password: "",
});

const confirmPassword = ref("");

const validationSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, t("error.signup_ps_8"))
    .max(16, "Password must be less than 16 characters")
    .matches(/[a-z]/, t("error.signup_ps_lower"))
    .matches(/[A-Z]/, t("error.signup_ps_upper"))
    .matches(/\d/, t("error.signup_ps_number"))
    .matches(/[!@#$%^&*(),.?":{}|<>]/, t("error.signup_ps_symbol"))
    .required(t("error.signup_ps_require")),
  confirmPassword: Yup.string()
    .required(t("error.signup_cps_require"))
    .oneOf([Yup.ref("password"), null], t("error.signup_ps_match")),
});

const { handleSubmit, resetForm } = useForm({
  validationSchema,
});

const initForm = () => {
  resetForm();
};

//form submit function
const resetPassword = handleSubmit(async () => {
  try {
    isLoading.value = true;
    await GlobalService.submitResetTradeAccountPassword(
      tenantId.value,
      formData.value
    );

    MsgPrompt.success(t("tip.passwordResetSuccess"))
      .then(() => store.dispatch(Actions.LOGOUT))
      .then(() => router.push({ name: "sign-in" }));
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
});

onMounted(async () => {
  isLoading.value = true;
  await store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  accountNumber.value = route.query.an;
  tenantId.value = route.params.tenantId;
  formData.value = {
    referenceId: route.query.uid,
    partyId: route.query.pid,
    token: route.query.token,
    password: "",
  };

  initForm();
  isLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(LanguageDropdown)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("form", {
          class: "form w-100",
          id: "kt_login_signin_form",
          "validation-schema": _unref(validationSchema)
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createTextVNode(_toDisplayString(_ctx.$t("title.changeAccountPassword")) + " ", 1),
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("title.account") + ": " + accountNumber.value), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("fields.newPassword")), 1),
              _createElementVNode("div", null, [
                _createElementVNode("i", {
                  class: _normalizeClass(["fa-solid fa-lg eye-icon", passwordShow_1.value ? 'fa-eye-slash' : 'fa-eye']),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (passwordShow_1.value = !passwordShow_1.value))
                }, null, 2),
                (passwordShow_1.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Hide"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t("action.show")), 1))
              ])
            ]),
            _createVNode(_unref(Field), {
              modelValue: formData.value.password,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.password) = $event)),
              tabindex: "2",
              class: "form-control form-control-lg form-control-solid",
              type: passwordShow_1.value ? 'text' : 'password',
              name: "password",
              autocomplete: "off"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.password) = $event)),
                  size: "large",
                  type: passwordShow_1.value ? 'text' : 'password',
                  name: "password"
                }, null, 8, ["modelValue", "type"])
              ]),
              _: 1
            }, 8, ["modelValue", "type"]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_unref(ErrorMessage), { name: "password" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("fields.confirmPassword")), 1),
              _createElementVNode("div", null, [
                _createElementVNode("i", {
                  class: _normalizeClass(["fa-solid fa-lg eye-icon", passwordShow_2.value ? 'fa-eye-slash' : 'fa-eye']),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (passwordShow_2.value = !passwordShow_2.value))
                }, null, 2),
                (passwordShow_2.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Hide"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t("action.show")), 1))
              ])
            ]),
            _createVNode(_unref(Field), {
              modelValue: confirmPassword.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((confirmPassword).value = $event)),
              class: "form-control form-control-lg form-control-solid",
              type: passwordShow_2.value ? 'text' : 'password',
              name: "confirmPassword",
              autocomplete: "off"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: confirmPassword.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((confirmPassword).value = $event)),
                  size: "large",
                  type: passwordShow_2.value ? 'text' : 'password',
                  name: "confirmPassword"
                }, null, 8, ["modelValue", "type"])
              ]),
              _: 1
            }, 8, ["modelValue", "type"]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_unref(ErrorMessage), { name: "confirmPassword" })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_unref(resetPassword) && _unref(resetPassword)(...args)), ["prevent"])),
              id: "kt_sign_in_submit",
              class: "btn btn-lg w-100 loginBtn"
            }, [
              (!isLoading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t("action.submit")), 1))
                : _createCommentVNode("", true),
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.pleaseWait") + "...") + " ", 1),
                    _hoisted_25
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 8, _hoisted_6)
      ])
    ])
  ]))
}
}

})